import { EditOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Button, Card, Spin, Table, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const AseguradoraProductoCobertura = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [model, setModel] = useState();
  const {
    params: { id }
  } = useRouteMatch();

  /* const getMonedas = async () => {
    try {
      const monedasResponse = await instanceRef.instance.get(`/moneda`);
      if (monedasResponse.data?.data) {
        setMonedas(monedasResponse.data?.data);
        const monedaGuaranies = Object.values(monedasResponse.data?.data).find(
          (item) => item.codigo === 'gs'
        );
        if (monedaGuaranies) {
          setMoneda(monedaGuaranies);
        } else {
          const codigoPrimeraMoneda = Object.keys(
            monedasResponse.data?.data
          )[0];
          setMoneda(monedasResponse.data?.data[codigoPrimeraMoneda]);
        }
      }
    } catch (error) {
      errorHandler(error, 'No se pudo obtener monedas');
      setLoading(false);
    }
  }; */

  const columns = [
    {
      title: 'Listado de coberturas',
      dataIndex: 'descripcion',
      key: 'descripcion'
    },
    {
      title: 'Grupo',
      dataIndex: ['grupo', 'descripcion'],
      key: ['grupo', 'descripcion']
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'left',
      render: (_, record) => {
        return (
          <Tooltip title="Editar">
            <Button
              icon={<EditOutlined />}
              type="text"
              size="middle"
              onClick={() => {
                history.push(
                  `/aseguradoraproducto/cobertura-form/${model.id}/${record.id}`
                );
              }}
            />
          </Tooltip>
        );
      }
    }
  ];

  const loadModel = async () => {
    try {
      setLoading(true);

      const response = await instanceRef.instance.get(
        `aseguradoraproducto/coberturas/${id}`
      );
      const data = response.data?.data;
      if (data) {
        setModel(data);
        setTitle(data.producto.descripcion);
      }

      setLoading(false);
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadModel();
    // getMonedas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ResponsiveContainer size="large">
      <Card
        title={`Configuración de coberturas - ${title}`}
        style={{ textAlign: 'left' }}
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          {/* moneda && monedas && monedas.length > 0 && (
            <>
              <MonedaSelector
                value={moneda.codigo}
                monedas={monedas}
                onChange={(e) => {
                  const selected = monedas.filter(
                    (item) => item.codigo === e.target.value
                  )[0];
                  setMoneda(selected);
                }}
              />
              <br />
              <br />
            </>
              ) */}

          <Button
            type="primary"
            ghost
            icon={<PlusSquareOutlined />}
            size="middle"
            onClick={() => {
              history.push(`/aseguradoraproducto/cobertura-form/${model.id}`);
            }}
          >
            Agregar
          </Button>
          <br />
          <br />
          <Table
            fixed
            scroll={false}
            style={{ maxWidth: '1000px' }}
            bordered
            dataSource={model?.cobertura}
            columns={columns}
            pagination={false}
            rowKey={(record) => record.id}
            size="small"
            width="auto"
          />
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
};

export default AseguradoraProductoCobertura;
